import {TriSelection} from 'api-types/ffconnect';

export interface CategorieDeLignes<T> {
  categorie_id: string;
  libelle_web: string;
  lignes: T[];
}

/**
 * Groupe une liste de lignes par catégorie en suivant l'ordre d'un tri_selection.
 * Utilisé côté panier et side panel panier pour afficher les lignes regroupées par catégorie web.
 *
 * - Les catégories sont triées alphabétiquement par libelle_web.
 * - Les catégories ne contenant aucune ligne présente dans la collection sont omises.
 */
export function groupLignesParCategorie<T>(
  lignes: T[],
  triSelection: TriSelection,
  getCode: (ligne: T) => string,
): CategorieDeLignes<T>[] {
  const lignesMap = new Map<string, T>();
  lignes.forEach((ligne) => {
    lignesMap.set(getCode(ligne), ligne);
  });

  return triSelection
    .slice()
    .sort((a, b) => a.libelle_web.localeCompare(b.libelle_web))
    .map(({categorie_id, libelle_web, articles}) => ({
      categorie_id,
      libelle_web,
      lignes: articles
        .map((article) => lignesMap.get(article.code))
        .filter((ligne): ligne is T => ligne !== undefined),
    }))
    .filter((categorie) => categorie.lignes.length > 0);
}
